export default __webpack_public_path__ + "static/media/arrowblack.3d8e1fa6.svg";